
const video_view = {
  started_watching: 'started-watching',
  watched: 'watched',
  analytics_id: 'analytics-id'
}

export default video_view